
import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { IColuna } from "app/types/IColuna";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { Parametro } from "app/types/Parametro";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import indexOf from "lodash/indexOf";
import sortBy from "lodash/sortBy";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { substituirItemEmArray } from "substituirItemEmArray";
import { useMenuConsultaProduto } from "../menu-consulta-produtos/useMenuConsultaProduto";
import { useMenuSubConsulta } from "../menu-sub-consulta-produto/useMenuSubConsultaProduto";
import { renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { Separador } from "../separador/Separador";
import { EntitesDadosEstoque, Estoque } from "./Estoque";
//import { traduzirColunaGridEstoque } from "./TraduzirColunaGridEstoque";

const NOME_GRID_ESTOQUE_PRODUTO = "ESTOQUE-PRODUTO-TABELA";

const ORDENACAO_COLUNAS_ESTOQUE = [
  "Filial", "Local Físico", "Quantidade", "Reservado",
  "Disponível", "Encomenda", "Em Trânsito", "Pedido ao Fornecedor",
  "Não Entregue Expedição", "Não Entregue Futura", "Disponível Lote",
  "Mostruário", "Reserva Mostruário", "Quantidade RMA", "R", "T"
];

export type EstoqueContainerProps = {
  item: IItemOrcamento
  //dadosEstoque?: PagedMessageResponse<EntitesDadosEstoque>,
  estoqueSelecionado?: EntitesDadosEstoque,
  onRemover: () => void,
  onVoltar: () => void,
  passos: Dict<string, () => void>,
  foraOrcamento: boolean
};

export const EstoqueContainer = (props: EstoqueContainerProps) => {
  const [colunas, setColunas] = useState<IColuna[]>([]);
  const [tamanhoFonte, setTamanhoFonte] = useState<number>(0);
  const [dados, setDados] = useState<PagedMessageResponse<EntitesDadosEstoque>>();
  const [parametros, setParametros] = useState<Parametro[]>([])
  const [permiteEngrenagemGrid, setPermiteEngrenagemGrid] = useState(false)
  const [estoqueSelecionado, setEstoqueSelecionado] = useState<EntitesDadosEstoque>(props.estoqueSelecionado)
  const [processando, setProcessando] = useState<boolean>(true)

  const isMounted = useRef<boolean>(true)
  useEffect(() => () => { isMounted.current = false }, [])

  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

  const colunasRef = useRef(colunas)
  colunasRef.current = colunas

  useMenuConsultaProduto(new Dict(Object.assign({}, props.passos.map)), props.onVoltar, props.item, props.foraOrcamento)
  const onRenderizarSubConsultaReact = useMenuSubConsulta(props)


  const atualizarParametros = async () => {
    const parametrosObtidos = await obterParametros({
        nomes: [
          "TRATAR_VENDAS_SOB_ENCOMENDA",
          "EXIBE_LOCAL_FISICO_CONSULTA_PRODUTOS", //por filial (precisa mudar)
          "VISUALIZA_FILIAL_CONSULTA_ESTOQUE", //452878 - mostra so filiais autorizadas
          "APRESENTAR_LOCAL_FISICO_CONSULTA_PRODUTO"
        ]
      })

    if (!isMounted.current) return
    setParametros(parametrosObtidos)
  }

  const permitidoAcaoFuncionalidade = async (siglaFuncionalidade: string, acao?: string) => await obterPermissao({ funcionalidade: siglaFuncionalidade, acao })


  const atualizarPermiteEngrenagemGrid = async () => {
    const permitido = await permitidoAcaoFuncionalidade("ORCAMENTO_ACESSO_ENGRENAGEM_GRID")

    if (!isMounted.current) return
    setPermiteEngrenagemGrid(permitido)
  }

  const valorParametro = (nome: string) => parametros.find((p) => p.Nome == nome)?.Valor;

  const onObterDadosEstoque = async () => {
    try {
      const resultado = await microuniversoApi.Produto.obterDadosEstoque({
        Codigo: props.item.Codigo,
        NumeroPagina: 1,
        RetornaTodasAsFiliais: valorParametro("VISUALIZA_FILIAL_CONSULTA_ESTOQUE") == "N", // 452878- nome parametro [Visualiza apenas filiais autorizadas na Consulta/Estoque]
        TamanhoPagina: 20
      });

      if (!isMounted.current) return
      setDados(resultado);

      if (resultado == null || resultado.Entities == null || resultado.Entities.length == 0) {
        onVoltar()
      }
    }
    catch (e) {
      tratamentoErroPadrao(e);
    }
    finally {
      globalMU.unblockUI();
    }

  }

  const toggleColunaSelecionada = useCallback(async (nomeColuna: string, selecionada: boolean) => {
    const colunaAtualizada = { ...colunasRef.current.find((c) => c.Nome == nomeColuna), Selecionada: selecionada };
    const colunasAtualizadas = substituirItemEmArray(colunasRef.current, (coluna) => coluna.Nome == nomeColuna, colunaAtualizada);

    setColunas(colunasAtualizadas);

    try {
      await microuniversoApi.Seguranca.atualizarColunasGrid(colunasAtualizadas, NOME_GRID_ESTOQUE_PRODUTO);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, []);

  const toggleSelecionarTodasColunas = useCallback(async (selecionar: boolean) => {
    const colunasAtualizadas = colunasRef.current.map(
      (c) => ({ ...c, Selecionada: selecionar } as IColuna)
    );
    setColunas(colunasAtualizadas);

    try {
      await microuniversoApi.Seguranca.atualizarColunasGrid(colunasAtualizadas, NOME_GRID_ESTOQUE_PRODUTO);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, []);

  const obterDadosIniciaisGrid = async () => {
    try {
            /* comentado 451466
      const ordenacao = [
        "Filial", "LocalFisico", "Quantidade", "Reservado", "Disponível", "Encomenda", "Em_Transito", "PedidoAoFornecedor", "qtdeNaoEntregueExpedicao",
        "quantidadeNaoEntregueFutura", "quantidadeDisponivelLote", "R", "T"
    ]
       
      setColunas(sortBy(dadosIniciais.Colunas, (coluna) => indexOf(ordenacao, coluna.Nome)));
      */
      const ordenacao = [
        "Filial", "Local Físico", "Quantidade", "Reservado", "Disponível", "Encomenda", "Em Trânsito", "Pedido ao Fornecedor", "Não Entregue Expedição",
        "Não Entregue Futura", "Disponível Lote", "R", "T"
      ]
      const dadosIniciais = await microuniversoApi.Seguranca.obterDadosGrid("Orcamento", NOME_GRID_ESTOQUE_PRODUTO);
      setColunas(sortBy(dadosIniciais.Colunas, (coluna) => indexOf(ordenacao, coluna.Nome)));
      

      if (!isMounted.current) return
      setColunas(sortBy(dadosIniciais.Colunas, (coluna) => indexOf(ORDENACAO_COLUNAS_ESTOQUE, coluna.Nome)));
      if (!isMounted.current) return
      setTamanhoFonte(dadosIniciais.TamanhoFonte);
    } catch (e) {
      tratamentoErroPadrao(e);
      globalMU.unblockUI()
    }
  };

  const alterarFonte = useCallback(async (tamanho: number) => {
    globalMU.blockUI();
    try {
      await microuniversoApi.Usuario.alterarFonte(NOME_GRID_ESTOQUE_PRODUTO, tamanho);

      if (!isMounted.current) return
      setTamanhoFonte(tamanho)
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, []);

  const onVoltar = useCallback(() => {
    props.onRemover()
    props.onVoltar()
  }, [props.onRemover, props.onVoltar])

  const onPassoSelecionado = useCallback((passo: string) => {
    props.onRemover()
    passosInterno.current.get(passo)()
  }, [props.onRemover])

  const onSelecionarDadoEstoque = useCallback((estoqueSelecionado: EntitesDadosEstoque) => {
    setEstoqueSelecionado(estoqueSelecionado)
  }, []);

  useEffect(() => {
    globalMU.blockUI()
    passosInterno.current.set("Estoque do Produto", () => { renderizarComponentReact(<EstoqueContainer {...props} estoqueSelecionado={estoqueSelecionado} />, "conteudo-pagina", true) })
    obterDadosIniciaisGrid()
    onObterDadosEstoque()
    atualizarParametros()
    atualizarPermiteEngrenagemGrid()
  }, [])

  useEffect(() => {
    if (colunas != null && colunas.length > 0 && dados != null && dados.Entities != null && dados.Entities.length > 0
      && parametros != null && parametros.length > 0) {
        setProcessando(false)
        globalMU.unblockUI()
      }
  }, [colunas, dados, parametros])

  useEffect(() => {
    onRenderizarSubConsultaReact(estoqueSelecionado, passosInterno.current)
  }, [estoqueSelecionado])


  return (processando ? <></> :
  <>
    <Breadcrumb2Container
      passos={passosInterno.current.keysToList()}
      exibirBotaoLimpar={false}
      exibirBotaoVoltar={true}
      onPassoSelecionado={onPassoSelecionado}
        onBotaoVoltarClicado={onVoltar}
      processando={processando}
      id="EstoqueBreadcrumb"
    />

    <Separador />

    <Estoque
      estoqueSelecionado={estoqueSelecionado}
      permiteEngrenagemGrid={permiteEngrenagemGrid}
      dadosEstoque={dados}
      onAlterarFonte={alterarFonte}
      //produto={valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? props.item.Codigo : props.item.Referencia}
      produto={props.item.CodigoProdutoExibicao && props.item.CodigoProdutoExibicao.trimEnd() != "" ? props.item.CodigoProdutoExibicao.trimEnd() : props.item.CodigoProduto.trimEnd()}
      descricao={props.item.Descricao}
      tamanhoFontePadrao={tamanhoFonte}
      corSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
      textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
      onToggleColunaSelecionada={toggleColunaSelecionada}
      onToggleSelecionarTodasColunas={toggleSelecionarTodasColunas}
      onSelecionarDadoEstoque={onSelecionarDadoEstoque}
      //451466 - colunas={colunas.map((coluna) => traduzirColunaGridEstoque({ coluna: coluna, nomeGrid: nomeGrid }))}
      colunas={colunas}
      mostrarColunaEncomenda={parseInt(valorParametro("TRATAR_VENDAS_SOB_ENCOMENDA")) > 0}
      mostrarColunaLocalFisico={valorParametro("EXIBE_LOCAL_FISICO_CONSULTA_PRODUTOS") == 'S' || valorParametro("APRESENTAR_LOCAL_FISICO_CONSULTA_PRODUTO") == 'S'}
    />
  </>
  )
}
